import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/447311754270" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors duration-300" aria-label="Contact us on WhatsApp" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} data-id="element-108">
      <motion.div animate={{
      boxShadow: ['0 0 0 0 rgba(37, 211, 102, 0.7)', '0 0 0 15px rgba(37, 211, 102, 0)']
    }} transition={{
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }} className="absolute inset-0 rounded-full" data-id="element-109" />
      <MessageCircle className="w-8 h-8 relative z-10" data-id="element-110" />
    </motion.a>;
}